<template>
  <div class="bars">
    <van-nav-bar
      title=""
      left-text="返回"
      left-arrow
      :fixed="true"
      @click-left="onClickLeft"
    />
    <!-- <div class="top">

      <div class="title">· 品牌分类 ·</div>
    </div> -->
    <div class="nav">
      <div
        class="one"
        @click="golist(v.id)"
        v-for="v in brand"
        :key="v.id"
      >
        <div
          class="xian"
          v-show="pids==v.id"
        ></div>
        <img
          :src="v.brand_logo"
          alt="图片"
        >
      </div>

    </div>
    <div class="product">
      <div class="wai">
        <div  class="side">
          <van-sidebar v-model="activeKey">
            <van-sidebar-item
              title="热卖产品"
              @click='side("产品分类",-1)'
            />
            <van-sidebar-item
              v-for="(v,i) in names"
              :key="v.id"
              :title="v.name"
              @click='side(v.name,v.id,i)'
            />
          </van-sidebar>
        </div>
      </div>

      <div  class="content">
        <div class="title">{{title}}</div>
        <div
          class="no"
          v-show="goods==null"
        >暂无商品~</div>
        <ul class="clearfix">
          <li
            v-for="v in goods "
            :key="v.id"
            @click="goproud(v.id,v.son_store_id,v.taocan,v.tmp_pack)"
            v-show="v.id ==4620 ? (fglo):true "
          >
            <img
              :src="v.thumb"
              alt=""
            >
            <p
              v-show="jf"
              class="price"
            ><span>超级VIP</span>{{login==0?"价格登录可见":"￥"+v.min_price}}</p>
            <p
              v-show="!jf"
              class="price"
            ></p>
            <p class="name">{{v.name}}</p>
            <p class="name shop"> {{(v.store_name)?v.store_name:''}}</p>
          </li>

        </ul>
       <div
      class="but"
      @click="open"
      v-show="[21,395].indexOf(classid)!=-1  || [21,395].indexOf($store.state.spid)!=-1 "
    >
    <img src="../../assets/jxs.png" alt="">
      <!-- <van-button
        type="danger"
        size="large"
      >分销商入口></van-button> -->
    </div>
      </div>
    </div>
    <!-- <div
      class="but"
      @click="open"
    >
      <van-button
        type="danger"
        size="large"
      >超级会员更省心，立即开通></van-button>
    </div> -->
    <div class=" mim" v-show="mx">
      <div class="mi" >
        <p>请输入密码浏览</p>
        <input
          type="text"
          v-model="value1"
        >
      </div>

      <div class="but">
        <van-button
          type="primary"
          size="large"
          @click="ok"
        >确认</van-button>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import {
  NavBar,
  GoodsAction, GoodsActionIcon, GoodsActionButton,
  Sidebar, SidebarItem,
  ImagePreview,
  Toast,
  Button,Popup
} from 'vant'
import { toast } from '../../config/jsbridge-mini'

Vue.use(NavBar)
  .use(SidebarItem)
  .use(Sidebar)
  .use(ImagePreview).use(GoodsAction)
  .use(GoodsActionButton)
  .use(GoodsActionIcon).use(Toast).use(Button).use(Popup)
export default {


  created () {
console.log(this.$store.state.addressc)
if(['湖州市','嘉兴市'].indexOf(this.$store.state.addressc) !=-1){
  this.fglo=true
}
    if (JSON.parse(localStorage.getItem('user')).id != 0) {
      this.login = 1
    } else {
    }

    if (this.$store.state.pid) {
      this.ids = this.$store.state.pid
    } else {
      this.$store.state.pid = this.$route.query.id
      this.ids = this.$route.query.id
    }
    if ([16, 17, 23,30].indexOf(this.$store.state.shopid) == -1) {
      this.jf = true
    } else {
      this.jf = false
    }
    this.axios.get('listGoods', { params: { store_id: this.$store.state.shopid, class_id: this.ids ,class_name:this.$route.query.name} }).then(res => {
      // if (res.data.code == 200) {
      //   this.navs = res.data.info
      // }
       if(this.$store.state.spid!=0){
      this.activeKey=this.$store.state.spid1+1
    // console.log(this.$store.state.soncname)
       
      this.axios.get('listGoodsByCateBrand', { params: { store_id: this.$store.state.shopid, class_id: this.$store.state.spid,class_name:this.$store.state.soncname } }).then(res => {
  //  console.log(res)
          this.goods = res.data.data.sort((a, b) => a.gsort - b.gsort)
        }).catch(ref => { })
    
 
    }else{
      this.goods = res.data.data.recommend.sort((a, b) => a.gsort - b.gsort)
      
    }
      res.data.data.threeClass.forEach(v => {
        // if (v.id == 196) {

        // } else if(v.id == 1634){} else {
        //   this.names.push(v)
        // }
          this.names.push(v)

      })
      this.brand = res.data.data.brand
     
    }).catch(ref => { })
   
    
    // if (this.$route.params.status) {
    //   this.side()
    //   console.log(1)
    // }
  },
  data () {
    return {
      jf: true,
      pids: "",
      ids: '',
      classid: '',
      login: 0,
      title: '',
      activeKey: 0,
      names: [],
      goods: [],
      brand: [],
      show:false,
      value:'',
      value1:'',
      fglo:false,
      mx: false,
      czf:1
    }
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    ok(){
      if (this.value1 == 131415) {
        if (this.czf == 3) {
          this.axios.get('listGoodsByCateBrand', { params: { store_id: this.$store.state.shopid, class_id: 3171, brand_id: this.pids, class_name:this.$store.state.soncname} }).then(res => {
          // console.log(res)
          this.goods = res.data.data.sort((a, b) => a.gsort - b.gsort)
      this.mx=false
          
        }).catch(ref => { })
        } else {
          this.axios.get('listGoodsByCateBrand', { params: { store_id: this.$store.state.shopid, class_id: 2684, brand_id: this.pids, class_name:this.$store.state.soncname} }).then(res => {
          // console.log(res)
          this.goods = res.data.data.sort((a, b) => a.gsort - b.gsort)
      this.mx=false
          
        }).catch(ref => { })
        }
      
      } else if (this.value1 == '112233') {
        let a=2861
        if (this.czf == 4) {
          a=3331
        }
        if (this.czf == 5) {
          a=3332
        }
        if (this.czf == 6) {
          a=3333
        }
        if (this.czf == 7) {
          a=3416
        }
        this.axios.get('listGoodsByCateBrand', { params: { store_id: this.$store.state.shopid, class_id: a, brand_id: this.pids, class_name:this.$store.state.soncname} }).then(res => {
          // console.log(res)
          this.goods = res.data.data.sort((a, b) => a.gsort - b.gsort)
          this.mx = false
        }).catch(ref => { })
      }
      else if (this.value1 == 'd5a8wc21s5') {
        this.axios.get('listGoodsByCateBrand', { params: { store_id: this.$store.state.shopid, class_id: 3174, brand_id: this.pids, class_name:this.$store.state.soncname} }).then(res => {
          // console.log(res)
          this.goods = res.data.data.sort((a, b) => a.gsort - b.gsort)
          this.mx = false
        }).catch(ref => { })
      } else if (this.value1 == '212223') {
        this.axios.get('listGoodsByCateBrand', { params: { store_id: this.$store.state.shopid, class_id: 3295, brand_id: this.pids, class_name:this.$store.state.soncname} }).then(res => {
          // console.log(res)
          this.goods = res.data.data.sort((a, b) => a.gsort - b.gsort)
          this.mx = false
        }).catch(ref => { })
      }
      else if (this.value1 == 'd5a8wc21s6') {
        this.axios.get('listGoodsByCateBrand', { params: { store_id: this.$store.state.shopid, class_id: 3177, brand_id: this.pids, class_name:this.$store.state.soncname} }).then(res => {
          // console.log(res)
          this.goods = res.data.data.sort((a, b) => a.gsort - b.gsort)
          this.mx = false
        }).catch(ref => { })
      }
      else if (this.value1 == '998579') {
        let a = 2749
        // console.log(this.czf)
        // if (this.czf == 2) {
        //    a=2749
        // } else {
        //   a = 2836
        // }
        this.axios.get('listGoodsByCateBrand', { params: { store_id: this.$store.state.shopid, class_id: this.czf==2?'2749':'2836', brand_id: this.pids, class_name:this.$store.state.soncname} }).then(res => {
          // console.log(res)
          this.goods = res.data.data.sort((a, b) => a.gsort - b.gsort)
          this.mx = false
        }).catch(ref => { })
      }else {
        Toast('密码错误')
      }
     
    },
    side (v, id,i) {
      
      document.documentElement.scrollTop=0
if([1750,1753,1752,1754].indexOf(id)!=-1){
  this.$router.push({name:'lp',query:{id}})
  return
}

      this.title = v
      this.$store.state.soncname=v
      this.classid = id
      this.$store.state.spid=id
      this.$store.state.spid1=i
      if(id==2684){
  this.mx=true
  return false
      }
      if(id==2861){
  this.mx=true
  return false
      }
      if(id==3295){
  this.mx=true
  return false
      }
      
      if(id==3174){
  this.mx=true
  return false
      }
      if(id==3177){
  this.mx=true
  return false
      }
      if(id==3171){
        this.mx = true
        this.czf=3
  
  return false
      }
      if(id==2836){
        this.mx = true
        this.czf=1
  
        return false
      }
      if (id == 2749) {
  this.czf=2
        
  this.mx=true
  return false
      }
      if(id==3331){
        this.mx = true
        this.czf=4
  
  return false
      }
      if(id==3332){
        this.mx = true
        this.czf=5
  
  return false
      }
      if(id==3333){
        this.mx = true
        this.czf=6
  
  return false
      }
      if(id==3416){
        this.mx = true
        this.czf=7
  
  return false
      }

      if (id == -1) {
        this.axios.get('listGoods', { params: { store_id: this.$store.state.shopid, class_id: this.ids, class_name:this.$route.query.name} }).then(res => {
          this.goods = res.data.data.recommend.sort((a, b) => a.gsort - b.gsort)
        }).catch(ref => { })
      } else {
        this.axios.get('listGoodsByCateBrand', { params: { store_id: this.$store.state.shopid, class_id: id, brand_id: this.pids, class_name:this.$store.state.soncname} }).then(res => {
          // console.log(res)
          this.goods = res.data.data.sort((a, b) => a.gsort - b.gsort)
          
        }).catch(ref => { })
      }
    },
    goproud (id,s,t,pj) {
      // console.log(s)
      if(pj==1){
      this.$router.push({ name: 'products11', query: { id,pj:1 } })

        return
      }
      if(s){
        this.$store.state.sonid=s
      this.$router.push({ name: 'products', query: { id } })

      }else{
        if(t==1){
      this.$router.push({ name: 'product', query: { id ,jian:1} })
return
        }
      this.$router.push({ name: 'product', query: { id } })

      }
      
      return
    },
    golist (id) {
      // console.log(this.classid)
      if (this.pids == id) {
        this.pids = 0
      } else {
        this.pids = id
      }
      if (this.classid == '' || this.classid == -1) {
        this.axios.get('listGoods', { params: { store_id: this.$store.state.shopid, class_id: this.ids,class_name:this.$route.query.name } }).then(res => {
          this.goods = []
          res.data.data.recommend.forEach(v => {
            if (v.brand == id) {
              this.goods.push(v)
            }
          });
        }).catch(ref => { })

        return false
      }
      if (this.classid == -1) {
        return false
      }
      this.axios.get('listGoodsByCateBrand', { params: { store_id: this.$store.state.shopid, class_id: this.classid, brand_id: this.pids,class_name:this.$store.state.soncname } }).then(res => {
        // console.log(res)
        this.goods = res.data.data.sort((a, b) => a.gsort - b.gsort)
      }).catch(ref => { })
      // this.$router.push({ name: 'productList', params: { id: 1 } })
    },
    open () {
        
//       if(
//         sessionStorage.getItem("lfj")==1
//       ){
//       this.$router.push({name:'yy'})
// return
//       }
      this.$router.push({name:'yz',query:{id:1}})
      // if (this.login == 0) {
      //   Toast('请先登录')
      //   this.$router.push('login')
      //   return
      // }
      // this.$router.push('vip')
    },
    
  }
}
</script>
<style lang="less" scoped>
.bars {
  padding-top: 4rem;
}
.but {
  padding: 0 0.2rem;
}
.top {
  position: relative;
  .title {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    height: 1rem;
    text-align: center;
    line-height: 1rem;
    background-color: rgba(256, 256, 256, 0.5);
    border-radius: 0.36rem 0.36rem 0 0;
    font-size: 0.4rem;
  }
}
.no {
  padding-top: 1rem;
  text-align: center;
}
.nav {
  background-color: #fff;
  position: fixed;
  top: 1rem;
  left: 0;
  width: 100%;
  height: 2.3rem;
  overflow-x: scroll; /*添加横向滚动条*/
  overflow-y: hidden;
  white-space: nowrap; /*不换行*/
  .one {
    width: 29%;
    margin: 2%;
    display: inline-block; /*设为inline-block*/
    position: relative;
    .xian {
      // border: 1px solid rgb(180, 13, 13);
      height: 0.1rem;
      width: 100%;
      background-color: rgb(180, 13, 13);
      position: absolute;
      top: 2rem;
      left: 0;
      z-index: 9999;
    }
  }
  .one img {
    width: 100%;
    height: 3.2rem;
  }
}
.product {
  display: flex;
  .wai {
    overflow: hidden;
    height: 100%;
  }
  .side {
    position: fixed;
    height: 77%;
    overflow-y: auto;

    left: 0;
    .van-sidebar {
      width: 1.333333rem;
    }
    .van-sidebar-item {
      background-color: #482e0d;
      color: #fff;
    }
    .van-sidebar-item--select {
      background-color: #ee0a24;
    }
  }
  .content {
    flex: 1;
    padding-left: 1.33333rem;
    .title {
      text-align: center;
      font-size: 0.4rem;
      height: 1rem;
    }
    ul {
      li {
        float: left;
        width: 45%;
        // padding: 0.266667rem 0.01rem 0.1rem 0.533333rem;
        // padding-left: 0.1rem;
        // padding-right: 0.1rem;
        height: 5.3rem;
        margin-left: 0.1rem;
        margin: 0.2rem 0.15rem 0.3rem 0.2rem;
        img {
          width: 3.9rem;
          height: 3.9rem;
        }
        .price {
          height: 0.9rem;
          line-height: 0.9rem;
          font-size: 0.4rem;
          font-weight: 700;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          span {
            font-weight: normal;
            color: #fff;
            background-color: #482e04;
            padding: 0.1rem 0.2rem;
            border-radius: 0.3rem;
          }
        }
        .name {
          color: #9f9f9f;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .shop{
          padding-top: 0.1rem;
          // color: rgb(239, 81, 81);
        }
      }
    }
  }
}
.mim{
   position: fixed;
  bottom: 0;
  background-color: #fff;
  width: 100%;
}

.mi {
  padding: 0.5rem;
  text-align: center;

  p {
    font-size: 0.5rem;
    margin: 0.5rem;
  }
  input {
    height: 1rem;
    width: 70%;
    border-radius: 5%;
    font-size: 0.4rem;
  }
  margin-bottom: 1rem;
}
</style>